export default {
      id: "ic_huawei_gallery-usage",
      viewBox: "0 0 120 36",
      url: "/" + "images/icons.3.109.2.svg#ic_huawei_gallery-usage",
      toString: function () {
        return this.url;
      }
    }